import React, { useState } from 'react';
import Cookies from 'js-cookie'; // <-- 1. Import Cookies
import Formviewer from './Formviewer';
import '../css/Forms.css';
import { formsData } from './Constants';

const Forms = () => {
  const [viewFormName, setViewFormName] = useState(null);
  const [searchText, setSearchText] = useState('');

  // --- ROBUST PARSING OF ALLOWED FORMS ---
  const allowedFormsStr = Cookies.get('allowed_forms');
  let allowedForms = [];
  try {
    if (allowedFormsStr && allowedFormsStr !== 'undefined') {
      // Try parsing as JSON first (expected format ["ALL"] or ["Blog",...])
      const parsed = JSON.parse(allowedFormsStr);
      allowedForms = Array.isArray(parsed) ? parsed : [parsed];
    }
  } catch (e) {
    // If it's a raw string like "ALL" or "Blog,Gallery", handle it
    console.error("Failed to parse allowed_forms cookie:", allowedFormsStr);
    allowedForms = allowedFormsStr ? allowedFormsStr.split(',') : [];
  }

  // 3. Filter by BOTH permissions and search text
  const filteredForms = formsData.filter(f => {
    // Check if user has 'ALL' access or explicit access to this specific form
    const isAllowed = 
        allowedForms.includes('ALL') || 
        allowedForms.includes(f.name) ||
        allowedForms.includes('*'); // Support alternative wildcards
    
    // Check if it matches the search input
    const matchesSearch = f.name.toLowerCase().includes(searchText.toLowerCase());
    
    return isAllowed && matchesSearch;
  });

  return (
    <div className="main">
      {!viewFormName ? (
        <div className="forms-container">
          {/* Header */}
          <div className="forms-header">
            <h1>Forms</h1>
            <input
              type="text"
              placeholder="Search"
              className="search-input"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>

          {/* Cards Grid */}
          <div className="forms-grid">
            {/* Displaying Filtered Forms */}
            {filteredForms.map((form, index) => (
              <div
                key={index}
                className="form-card"
                onClick={() => setViewFormName(form.name)}
              >
                <div className="card-icon">
                  📄
                </div>
                <h3>{form.name}</h3>
                <p>{form.description || 'No description available'}</p>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <Formviewer
          formName={viewFormName}
          onBack={() => setViewFormName(null)}
        />
      )}
    </div>
  );
};

export default Forms;